/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "98d0f57bdea0f5dadec2bcb7e429a27f76e36d0e";
